import React, { Component } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import nth from 'lodash/nth'
import BarChart from 'recharts/es6/chart/BarChart'
import Bar from 'recharts/es6/cartesian/Bar'
import Cell from 'recharts/es6/component/Cell'
import XAxis from 'recharts/es6/cartesian/XAxis'
import ResponsiveContainer from 'recharts/es6/component/ResponsiveContainer'

export default class SalaryBarChart extends Component {
  static propTypes = {
    salaryDistribution: PropTypes.any.isRequired,
  }

  render() {

    const { salaryDistribution } = this.props
    const ticks = [get(nth(salaryDistribution, 0), 'salary'), get(nth(salaryDistribution, 2), 'salary'), get(nth(salaryDistribution, 4), 'salary')]

    return (
      <div style={{height: 160, minWidth: 200, maxWidth: 300, margin: '0 auto'}}>
        <ResponsiveContainer>
          <BarChart data={salaryDistribution} width={600} height={400} margin={{top: 0, right: 20, bottom: 0, left: 20}}>
            <Bar dataKey='height'>
              {salaryDistribution.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={ entry.is_target ? "#34cbaa" : "#85e0cc"}/>
              ))}
            </Bar>
            <XAxis dataKey="salary" ticks={ticks} tickMargin={5}/>
          </BarChart>
        </ResponsiveContainer>
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/components/SalaryBarChart.js